var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCtScan = function SvgCtScan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ct_scan{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CT_Scan",
    "data-name": "CT Scan"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "ct_scan",
    points: "65.92 77.61 41.41 77.61 45.78 54.85 61.54 54.85 65.92 77.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct_scan",
    d: "M57.13,27.15a20.13,20.13,0,0,1,6.28,37.44l-1.82-9.47a11.38,11.38,0,1,0-15.86,0l-1.82,9.47a20.13,20.13,0,0,1,6.28-37.44,19.58,19.58,0,0,1,6.94,0Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCtScan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ct_scan.deb16154.svg";
export { ForwardRef as ReactComponent };